import ArrowRouteIcon from '../../../assets/arrow-route-icon';
import Button from '../../../components/button';
import React from 'react';

const OriginToDestination = ({ onClick, origin, destination }) => {
  return (
    <div className="bg-white flex justify-between p-4 md:p-10 rounded-lg border border-gray-200">
      <div className="flex flex-1 justify-center md:justify-start items-center gap-5 lg:gap-10">
        <div className="flex flex-col items-start">
          <span className="text-left text-sm md:text-base text-[#757575]">Asal</span>
          <span className="text-left text-base md:text-xl font-semibold">{origin}</span>
        </div>
        <ArrowRouteIcon />
        <div className="flex flex-col items-start">
          <span className="text-left text-sm md:text-base text-[#757575]">Tujuan</span>
          <span className="text-left text-base md:text-xl font-semibold">{destination}</span>
        </div>
      </div>
      <div className="hidden md:block">
        <Button text="Ubah Pencarian" isActive={false} onClick={onClick} />
      </div>
    </div>
  );
};

export default OriginToDestination;
